import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { AmplifyService } from 'aws-amplify-angular';
import { Router } from '@angular/router';

@Component({
    selector     : 'login',
    templateUrl  : './login.component.html',
    styleUrls    : ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class LoginComponent implements OnInit
{
    loginForm: FormGroup;
    errorMessage: string;
    loading: boolean;

    // Protected
    protected logger: any;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        protected amplifyService: AmplifyService,
        protected router: Router,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder
    )
    {
        // Set logger
        this.logger = this.amplifyService.logger('LoginComponent');

        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            email   : ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });
    }

    onSubmit(): void {
        this.errorMessage = '';
        this.loading = true;

        const form = this.loginForm.value;

        this.amplifyService.auth()
            .signIn(form.email, form.password)
            .then((user: any) => {
                if (user['challengeName'] === 'SMS_MFA' || user['challengeName'] === 'SOFTWARE_TOKEN_MFA') {
                    this.amplifyService.setAuthState({ state: 'confirmSignIn', user });
                  } else if (user['challengeName'] === 'NEW_PASSWORD_REQUIRED') {
                    this.amplifyService.setAuthState({ state: 'requireNewPassword', user });
                  } else {
                    this.amplifyService.setAuthState({ state: 'signedIn', user });
                    this.router.navigate(['dashboard']);
                  }
            })
            .catch((err: any) => {
                this.handleError(err);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private handleError(err: any): void {
        if (!err) {
          this.errorMessage = null;
          return;
        }
        this.errorMessage = err.message || err;
        this.logger.error(this.errorMessage);
    }
}
